import { initializeI18n } from '@bassitai/shared-i18n';
import { ThemeProvider, defaultTheme, registerDefaultComponents } from '@company/shared-ui';
import React from 'react';
import { createRoot } from 'react-dom/client';

import '@/index.css';
import App from '@/App';

let registryInitialized = false;
let platformInitialized = false;

function initializeComponentRegistry() {
  if (registryInitialized) {
    return;
  }
  registerDefaultComponents();
  registryInitialized = true;
}

function initializePlatformRuntime() {
  if (platformInitialized) {
    return;
  }

  initializeI18n();
  platformInitialized = true;
}

export function renderApp(container: HTMLElement) {
  initializeComponentRegistry();
  initializePlatformRuntime();
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={defaultTheme}>
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );
}
